import { render, staticRenderFns } from "./getSsygList.vue?vue&type=template&id=4674d204&"
import script from "./getSsygList.vue?vue&type=script&lang=js&"
export * from "./getSsygList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports